export default __webpack_public_path__ + "static/media/oracle.db511d36.svg";